"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCtaTicketProperty = exports.ctaTicketPropertyDefinition = void 0;
exports.ctaTicketPropertyDefinition = {
    view: { label: 'CTA ticket' },
    constraints: [
        {
            name: 'orderedProperties',
            argument: [
                'cta-button-label',
                'cta-ticket-service',
                'cta-start-date',
                'cta-end-date',
            ],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'cta-ticket',
};
const isCtaTicketProperty = (prop) => {
    return prop.name === exports.ctaTicketPropertyDefinition.name;
};
exports.isCtaTicketProperty = isCtaTicketProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3RhLXRpY2tldC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2N0YS10aWNrZXQucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSwyQkFBMkIsR0FBRztJQUN6QyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsWUFBWSxFQUFFO0lBQzdCLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLG1CQUFtQjtZQUN6QixRQUFRLEVBQUU7Z0JBQ1Isa0JBQWtCO2dCQUNsQixvQkFBb0I7Z0JBQ3BCLGdCQUFnQjtnQkFDaEIsY0FBYzthQUNmO1NBQ0Y7S0FDRjtJQUNELElBQUksRUFBRSxtQkFBbUI7SUFDekIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsWUFBWTtDQUNhLENBQUE7QUFJMUIsTUFBTSxtQkFBbUIsR0FBRyxDQUFDLElBQWtCLEVBQTZCLEVBQUU7SUFDbkYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLG1DQUEyQixDQUFDLElBQUksQ0FBQTtBQUN2RCxDQUFDLENBQUE7QUFGWSxRQUFBLG1CQUFtQix1QkFFL0IifQ==